<template>
    <div>
    
      <div style="margin-top:56px;" >
            <div class="container" style="margin-top:0px">
                <div class="row  lang-header">
                    <div class="col-md-5" style="text-align: center;">
                      <img src="https://tsyyapi.dctechonline.cn/static/images/p3.jpg" class="home-img" style="opacity:0.8;width:90%;margin-bottom:5px;"/>
                    </div>
                    <div class="col-md-7">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="step-box">
                              <div class="step-title">入门级</div>
                              <div class="step-age"><div class="age">8-10岁</div></div>
                              <div class="step-desc">讲解Python语言的基础知识，变量，条件，循环，列表等概念。课堂讲解+课后练习相结合</div>
                            </div>
                          </div>
    
                          <div class="col-md-4">
                            <div class="step-box">
                              <div class="step-title">进阶级</div>
                              <div class="step-age"><div class="age">10-15岁</div></div>
                              <div class="step-desc">讲解Python语言的高级特性，数据处理，Turtle库等特性。课堂讲解+课后练习相结合</div>
                            </div>
                          </div>
    
                          <div class="col-md-4">
                            <div class="step-box">
                              <div class="step-title">比赛级</div>
                              <div class="step-age"><div class="age">10岁+</div></div>
                              <div class="step-desc">针对NOC，蓝桥杯，NOI等国内外竞赛的教学</div>
                            </div>
                          </div>
                        </div>
    
                        <div style="text-align: center;margin-top:20px;">
                            <button class="btn btn-primary" style="background:#04b2c5;border-color:#04b2c5;margin-right:10px"
                          @click="toPythonClass()">进入Python课堂</button>
                            <button class="btn btn-primary" style="background:#04b2c5;border-color:#04b2c5"
                          @click="toClass()">Python对比学习</button></div>
                    </div>
                 
                
                </div>
    
                
            </div>
        </div>
        <div class="container" style="margin-top:50px">
       
         
          
          
    
    
          <div class="row" style="margin-top: 60px;">
            <div class="col-md-6" style="margin-bottom:20px">
              <h4 class="text-center mb-4">Python入门课程</h4>
              <ul class="list-group">
                <li class="list-group-item">第1节课：认识编程和Python</li>
                <li class="list-group-item">第2节课：变量和数据类型</li>
                <li class="list-group-item">第3节课：输入和输出</li>
                <li class="list-group-item">第4节课：条件语句</li>
                <li class="list-group-item">第5节课：循环语句</li>
                <li class="list-group-item">第6节课：函数和过程</li>
                <li class="list-group-item">第7节课：数组和列表</li>
                <li class="list-group-item">第8节课：图像显示</li>
                <li class="list-group-item">第9节课：进一步学习条件语句</li>
                <li class="list-group-item">第10节课：进一步学习循环语句</li>
                <li class="list-group-item">第11节课：进一步学习函数</li>
                <li class="list-group-item">第12节课：综合项目挑战</li>
              </ul>
            </div>
            <div class="col-md-6" style="margin-bottom:20px">
              <h4 class="text-center mb-4">Python进阶课程</h4>
              <ul class="list-group">
                <li class="list-group-item">第1节课：集合与字典</li>
                <li class="list-group-item">第2节课：集合类型综合运用</li>
                <li class="list-group-item">第3节课：递归函数</li>
                <li class="list-group-item">第4节课：类的基本概念</li>
                <li class="list-group-item">第5节课：类的继承</li>
                <li class="list-group-item">第6节课：类的综合运用</li>
                <li class="list-group-item">第7节课：文件操作</li>
                <li class="list-group-item">第8节课：Turtle库的使用</li>
                <li class="list-group-item">第9节课：Python综合运用（1）</li>
                <li class="list-group-item">第10节课：Python综合运用（2）</li>  
              </ul>
            </div>
          </div>
    
          <div class="row mt-5">
            
            <div class="col-md-7">
              <h3 style="margin:20px 0px">教学师资</h3>
                <p style="text-align: left;">团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。</p>
                <p style="text-align: left;">首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。</p>
            </div>
    
            <div class="col-md-5">
              <img src="/images/teach.jpg" class="img-fluid" alt="Processing编程教室">
            </div>
          </div>
    
          <hr/>
    
          <div class="row" style="margin-top:50px;margin-bottom:50px;">
            <div class="col-md-7">
                <img src="/images/back2.jpg" class="img-fluid" alt="Processing编程教室"></img>
    
            </div>
            <div class="col-md-5">
                <h3 style="margin:20px 0px">我要上课</h3>
                
                <div style="margin-bottom:20px">联系课程顾问获取课程价格以及上课方式</div>
                <div><img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" style="max-width:180px"/></div>
            </div>
          </div>
          
        </div>
        <bottom></bottom>
    </div>
      </template>
      
      <script>
      import bottom from '../components/bottom.vue';
      export default {
        name: 'ProcessingCourse',
        components:{
            bottom
        },
        methods:{
            toPythonClass(){
                this.$router.push('pythonclass');
            },
          toClass(){
            this.$router.push('python-compare');
          }
        },
        mounted(){
            $('#element').toast('show')
        }
      }
      </script>
      
      <style>
      h1 {
        font-size: 48px;
        font-weight: bold;
      }
      
      h3 {
        font-size: 32px;
        font-weight: bold;
      }
      
      p {
        font-size: 18px;
      }
      
      .list-group-item {
        font-size: 16px;
        font-weight: bold;
      }
      
      .img-fluid {
        max-width: 100%;
        height: auto;
      }
    
      @media (max-width:800px) {
        .list-group-item {
            font-size: 18px;
            font-weight: bold;
        }
    
        h3{
            font-size:24px;
        }
      }
      </style>